import { Component, OnInit, Input, OnDestroy, OnChanges, SimpleChanges } from '@angular/core';
import createAutoCorrectedDatePipe from 'text-mask-addons/dist/createAutoCorrectedDatePipe';
import { FormBuilder } from '@angular/forms';
import { MeetingsService } from '@app/services/meetings/meetings.service';
import { Meetings } from '@app/models/meetings';
import { MemberformService } from '@app/services/states/memberform/memberform.service';
import { IMeetingsview } from '@app/models/memberform/memberformviewstate';
import { Subscription } from 'rxjs';
import { Sort } from '@angular/material/sort';
import { ActivatedRoute } from '@angular/router';
import { AuthService } from '@app/services/auth/auth.service';
import { PermissionsService } from '@app/services/permissions/permissions.service';

@Component({
  selector: 'app-meetings',
  templateUrl: './meetings.component.html',
  styleUrls: ['./meetings.component.css']
})
export class MeetingsComponent implements OnInit, OnDestroy, OnChanges {
  @Input() institutionid: number;
  memberid;
  minmaxyear = { minYear: '1920', maxYear: '2030' };
  meetings: Meetings[] = [];
  autoCorrectedDatePipe = createAutoCorrectedDatePipe('yyyy-mm-dd', this.minmaxyear);
  public mask = [/[1-9]/, /\d/, /\d/, ' ', /\d/, /\d/]; // zipcode
  public maskdatum = [/[129]/, /[?09]/, /\d/, /\d/, '-', /\d/, /\d/, '-', /\d/, /\d/];
  mobiledevice = false;
  meetingsform;
  
  permissions;
  meetingsview: IMeetingsview = null;
  subscriptions: Subscription[] = [];
  // tslint:disable-next-line:max-line-length
  constructor(
    private fb: FormBuilder,
    private meetingService: MeetingsService,
    private authService: AuthService,
    private memberformService: MemberformService,
    private activatedRoute: ActivatedRoute,
    private permissionsService: PermissionsService) {
  }

  ngOnInit() {
    this.meetingsform = this.fb.group({
      memberId: ['', ''],
      InstitutionId: ['', ''],
      roleId: ['', ''],
      fromDate: ['', ''],
      toDate: ['', ''],
      OnlyIncludeOwnLodgeMeetings: [false, '']
    });
    this.authService.isMobileDevice.subscribe(mobile => {
      this.mobiledevice = mobile;
    });
    this.activatedRoute.paramMap.subscribe(paramMap => {
      this.memberid = +paramMap.get('id');
      this.meetings = [];
    });
    this.permissionsService.selectedrole.subscribe(x => {
      if (x) {
        this.meetingsform.patchValue({ roleId: x.roleId });
      }
    });
    this.meetingsview = this.memberformService.memberformstate.meetingsview;
    if (localStorage.getItem('memberformstate')) {
      const _memberformstate = JSON.parse(localStorage.getItem('memberformstate'));
      this.meetingsview = _memberformstate.meetingsview;
      this.meetingsform.get('fromDate').setValue(this.meetingsview.fromdate);
      this.meetingsform.get('toDate').setValue(this.meetingsview.todate);
      this.meetingsform.get('OnlyIncludeOwnLodgeMeetings').setValue(this.meetingsview.onlyactualinstitution);
      if (this.meetingsform.get('fromDate').value) {
        this.viewPresence();
      }
    }
  }

  ngOnDestroy() {
    this.subscriptions.forEach(subscription => {
      subscription.unsubscribe();
    });
  }

  ngOnChanges(changes: SimpleChanges) {
    if (changes && this.meetingsform) {
      if (changes.memberid) {
        this.meetingsform.patchValue({ memberId: changes.memberid.currentValue });
      }
      if (changes.institutionid) {
        this.meetingsform.patchValue({ InstitutionId: changes.institutionid.currentValue })
      }
    }
  }

  get fromDate() {
    return this.meetingsform.get('fromDate');
  }

  get toDate() {
    return this.meetingsform.get('toDate');
  }

  get OnlyIncludeOwnLodgeMeetings() {
    return this.meetingsform.get('OnlyIncludeOwnLodgeMeetings');
  }

  viewPresence() {
    this.meetingsform.get('memberId').setValue(this.memberid);
    this.meetingsform.get('InstitutionId').setValue(this.institutionid.toString());
    this.subscriptions.push(this.meetingService.getMeetings(this.meetingsform.value as any).subscribe(meetings => {
      this.meetings = meetings;
    }));
  }

  updateMeetingsview() {
    this.memberformService.updateMeetingsview(this.meetingsform.value);
  }

  sortData(sort: Sort) {
    const data = this.meetings.slice();
    if (!sort.active || sort.direction === '') {
      this.meetings = data;
      return;
    }
    this.meetings = data.sort((a, b) => {
      const isAsc = sort.direction === 'asc';
      switch (sort.active) {
        case 'meeting': return this.compare(a.issue, b.issue, isAsc);
        case 'meetingDate': return this.compare(a.meetingDate, b.meetingDate, isAsc);
        case 'inst': return this.compare(a.institutionId, b.institutionId, isAsc);
        default: return 0;
      }
    });
  }

  compare(a: number | string | Date, b: number | string | Date, isAsc: boolean) {
    return (a < b ? -1 : 1) * (isAsc ? 1 : -1);
  }

  searchtest(term: string) {
    if (!term) {
      this.meetings = this.meetings;
    } else {
      this.meetings = this.meetings.filter(x =>
        x.issue.trim().toLowerCase().includes(term.trim().toLowerCase())
      );
    }
  }

}
